module.exports = __webpack_public_path__ + "static/media/location.7a211be8.svg";